import { render, staticRenderFns } from "./VehicleLeaseSummaryTable.vue?vue&type=template&id=2260a6d7&scoped=true&"
import script from "./VehicleLeaseSummaryTable.vue?vue&type=script&lang=js&"
export * from "./VehicleLeaseSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLeaseSummaryTable.vue?vue&type=style&index=0&id=2260a6d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2260a6d7",
  null
  
)

export default component.exports